export default __webpack_public_path__ + "static/media/about-rural-suburban-urban-healthcare.963836cd.png";